module.exports = __webpack_public_path__ + "imgUser.png";